exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.login-wrap[data-v-23258daa]{background-color:#324152;height:100%\n}\n[data-v-23258daa] .el-tab-pane{min-height:500px\n}\n", "", {"version":3,"sources":["/home/jenkins/agent/workspace/fastpay-system-manager-merchant/src/components/cuscom/passwd/index.vue"],"names":[],"mappings":";AACA,6BAA6B,yBAAyB,WAAW;CAChE;AACD,+BAA+B,gBAAgB;CAC9C","file":"index.vue","sourcesContent":["\n.login-wrap[data-v-23258daa]{background-color:#324152;height:100%\n}\n[data-v-23258daa] .el-tab-pane{min-height:500px\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-23258daa","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/cuscom/passwd/index.vue
// module id = NVDn
// module chunks = 18